import { css } from '@emotion/react';
import { OverlayContainer } from '@react-aria/overlays';
import type { OverlayTriggerState } from '@react-stately/overlays';
import type { Property } from 'csstype';
import { Button, space } from 'folio-common-components';
import * as React from 'react';
import { ModalDialog } from './modal-dialog';

export const ConfirmDialog: React.FC<
  React.PropsWithChildren<{
    title: string;
    confirmText?: string;
    dismissText?: string;
    onConfirm: () => void;
    overlayState: OverlayTriggerState;
    maxWidth?: Property.MaxWidth<string | number>;
  }>
> = ({
  title,
  confirmText = 'OK',
  dismissText = 'Avbryt',
  onConfirm,
  overlayState,
  maxWidth = '320px',
  children,
}) => {
  return overlayState.isOpen ? (
    <OverlayContainer>
      <ModalDialog
        title={title}
        isOpen
        onClose={overlayState.close}
        // eslint-disable-next-line jsx-a11y/no-autofocus
        autoFocus={true}
        css={css`
          max-width: ${maxWidth};
        `}
      >
        {children}
        <div
          css={css`
            display: grid;
            grid-template-columns: 1fr 1fr;
            ${space([16], 'gap', 'margin-top')};
          `}
        >
          <Button onClick={() => overlayState.close()} level="secondary">
            {dismissText}
          </Button>
          <Button
            onClick={() => {
              overlayState.close();
              onConfirm();
            }}
          >
            {confirmText}
          </Button>
        </div>
      </ModalDialog>
    </OverlayContainer>
  ) : null;
};
